import {ApiException} from "@/domain/core/exception/exceptions";
import {emptyListResponse} from "@/domain/core/utils/django";



const state = {
    roles: {...emptyListResponse},
    role: {},
    permissions: {},
    visibleRoles: [],
}

export const getters = {
    roles: state => state.roles,
    role: state => state.role,
    permissions: state => state.permissions,
    visibleRoles: state => state.visibleRoles,
}


export const mutations = {
    roles(state, roles) {
        state.roles = roles
    },
    role(state, role) {
        state.role = role
    },
    deleteRole(state, id) {
        state.roles.results = state.roles.results.filter(role => role.id !== id)
    },
    permissions(state, permissions) {
        state.permissions = permissions
    },
    visibleRoles(state, roles) {
        state.visibleRoles = roles
    }
}


export const actions = rolesService => ({
    async fetchRoleList({commit}, {filters, pagination, sorting}) {
        try {
            const roles = await rolesService.fetchRoleList(filters, pagination, sorting)
            commit('roles', roles)
        } catch (e) {
            if (e instanceof ApiException)
                commit('roles', emptyListResponse)
            throw e
        }
    },
    async deleteRole({commit}, id) {
        await rolesService.deleteRole(id)
        commit('deleteRole', id)
    },
    async fetchRole({commit}, id) {
        const role = await rolesService.fetchRole(id)
        commit('role', role)
    },
    async updateRole({commit}, {id, data}) {
        commit('role', await rolesService.updateRole(id, data))
    },
    async createRole({commit}, data) {
        commit('role', await rolesService.createRole(data))
    },
    async fetchPermissions({commit}) {
        commit('permissions', await rolesService.fetchPermissions())
    },
    async fetchVisibleRolesByContext({commit}, {contextType, contextId}) {
        const roles = await rolesService.fetchVisibleRolesByContext(contextType, contextId)
        commit('visibleRoles', roles)
        return roles
    }
})

export default rolesService => ({
    namespaced: true,
    state,
    getters,
    mutations,
    actions: actions(rolesService)
})

